document.addEventListener("DOMContentLoaded", updateFreeShippingWidget);
document.addEventListener("cart:updated", updateFreeShippingWidget);
document.addEventListener("cart:drawer-updated", updateFreeShippingWidget);

function updateFreeShippingWidget() {
  const box = document.querySelector(".free-shipping-box");
  if (!box) return;

  const cartTotal = parseInt(box.dataset.cartTotal, 10);
  const threshold = parseInt(box.dataset.threshold, 10);

  // Detect currency — fallback logic
  let currency = window.Shopify?.currency?.active;

  if (!currency && window.Shopify?.country) {
    if (window.Shopify.country === "MY") currency = "MYR";
    if (window.Shopify.country === "SG") currency = "SGD";
  }

  if (!currency) currency = "SGD";

  const currencySymbol = {
    SGD: "S$",
    MYR: "RM",
  }[currency] || "";

  const amountRemaining = threshold - cartTotal;

  const messageEl = box.querySelector(".free-shipping-message");
  const barFill = box.querySelector(".free-shipping-progress-fill");

  const formattedRemaining =
    currencySymbol + (amountRemaining / 100).toFixed(2);

  if (amountRemaining > 0) {
    messageEl.textContent = box.dataset.msgRemaining.replace("{amount}", formattedRemaining);
    messageEl.classList.remove("free-shipping-achieved");
  } else {
    messageEl.textContent = box.dataset.msgUnlocked;
    messageEl.classList.add("free-shipping-achieved");
  }

  const progress = Math.min((cartTotal / threshold) * 100, 100);
  barFill.style.width = progress + "%";
}
